module.exports = __webpack_public_path__ + "images/2-hovera3d439deadba6833f7aaa5ad9272737e.svg";